import { render, staticRenderFns } from "./MasterSVG.vue?vue&type=template&id=4ea81d64&scoped=true"
import script from "./MasterSVG.vue?vue&type=script&lang=js"
export * from "./MasterSVG.vue?vue&type=script&lang=js"
import style0 from "./MasterSVG.vue?vue&type=style&index=0&id=4ea81d64&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ea81d64",
  null
  
)

export default component.exports